import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import './slide-5.less';


export const Slide5 = ({
}) => (
    <div className="trip-board-onboarding-slide5">
        <div className="trip-board-onboarding-slide5__gray-circle"/>

        <div className="trip-board-onboarding-slide5__property-card-1 trip-board-onboarding-slide5__board">
            <div className="header text-emphasis">
                <FormattedHTMLMessage id={'tripboards.main.empty.board4'} defaultMessage={''} description="Trip Board title 1"/>
            </div>
            <div className="left-content"/>
            <div className="right-content">
                <div className="right-content__top" />
                <div className="right-content__bottom" />
            </div>
        </div>
        <div className="trip-board-onboarding-slide5__property-card-2 trip-board-onboarding-slide5__board">
            <div className="header text-emphasis">
                <FormattedHTMLMessage id={'tripboards.main.empty.board3'} defaultMessage={''} description="Trip Board title 2"/>
            </div>
            <div className="left-content"/>
            <div className="right-content">
                <div className="right-content__top" />
                <div className="right-content__bottom" />
            </div>
        </div>
    </div>
);

export default Slide5;



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/content/static/slide-5/slide-5.js